export const challanType = [
  { id: '1', label: 'Supply of Liquid Gas' },
  { id: '2', label: 'Job Work' },
  { id: '3', label: 'Supply on Approval' },
  { id: '4', label: 'Others' },
];
